import React from 'react';
import {Tabs} from 'antd';
import {CommandDto} from "../api";
import BasicCommandButtonsTab from "./BasicCommandButtonsTab";
import PredefinedVariablesTab, {PredefinedVariable} from "./PredefinedVariablesTab";
import {hasRole, ROLES} from "./misc/RolesHelper";
import {useKeycloak} from "@react-keycloak/web";

const TestCreationTabs = ({onCommandCardData, onPredefinedVariables, predefinedVariables, onRemoveVariable, abstractCommands}) => {

    const {keycloak} = useKeycloak();

    // Daten von Formular durchreichen an den Test
    const handleCommandCard = (data: CommandDto) => {
        onCommandCardData(data);
    }

    // Neue Variable an den Test durchreichen
    const handlePredefinedVariables = (data: PredefinedVariable) => {
        onPredefinedVariables(data);
    }

    const handleRemoveVariable = (key: string) => {
        onRemoveVariable(key);
    }

    const userHasRequiredRole = hasRole([ROLES.GLOW_ADMIN, ROLES.GLOW_TEST_DEVELOPER, ROLES.GLOW_TEST_DESIGNER], keycloak);

    const items = [
        {
            label: "VARIABLEN",
            key: "variables",
            children: <PredefinedVariablesTab variables={predefinedVariables}
                                              canEdit={userHasRequiredRole}
                                              onPredefinedVariables={handlePredefinedVariables}
                                              onRemoveVariable={handleRemoveVariable}  />
        },
    ];

    if (userHasRequiredRole) {
        items.unshift({
            label: "BEFEHLE",
            key: "commands",
            children: <BasicCommandButtonsTab onCommandCardData={handleCommandCard} />
        });
    }


    return (
        <Tabs
            defaultActiveKey="2"
            centered
            items={items}
        />
    );
}
export default TestCreationTabs;